import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button, Spinner, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormInput from "../FormInput";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import swal from 'sweetalert2';
import Preloader from "../Preloader";
import '../../styles/common.css';
import { getProductById, saveProductData, updateProductData } from "../../redux/actions/ManageProductActions";

const AddProduct = ({ show, onHide, editId }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();

  const {
    AuthReducer: { auth, errors },
    productReducer: { loadingProduct, errorsProduct, productDetails, changedProductStatus }
  } = useSelector((state) => state);

  useEffect(() => {
    setFormData({});
    if (editId) {
      dispatch(getProductById(auth?.token, editId));
    }
  }, [auth, editId]);

  useEffect(() => {
    if (editId && productDetails) {
      setFormData({
        product_name: productDetails?.name,
        category_id: productDetails?.category_id,
        price: productDetails?.price,
        description: productDetails?.description,
        imagePreview: productDetails?.image,
        video_url: productDetails?.video_url,
        manufactured_by: productDetails?.manufactured_by,
        location: productDetails?.location
      });
    }
  }, [productDetails, editId]);

  const inputHandler = (e) => {
    const { value, name, files } = e.target;
    if (files && files.length > 0) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    }
    const formDataToSend = new FormData();
    for (let key in formData) {
      if (formData[key]) {
        formDataToSend.append(key, formData[key]);
      }
    }
    if (editId) {
      dispatch(updateProductData(auth?.token, formDataToSend, editId));
    } else {
      dispatch(saveProductData(auth?.token, formDataToSend));
    }
  };


  useEffect(() => {
    if (errors && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide();
    }
  }, [errors, dispatch, onHide]);

  useEffect(() => {
    console.log(changedProductStatus,"changedProductStatus")
    if (changedProductStatus?.success) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedProductStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });
      dispatch({ type: 'RESET_PRODUCT_STATUS' });
    }
  }, [changedProductStatus, dispatch, onHide]);

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          {editId && productDetails ? t("Update Product") : t("Add Product")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorsProduct?.data?.message && (
          <div className="alert alert-danger">
            {errorsProduct?.data?.message}
          </div>
        )}
        <Row>
          <Col lg={6}>
            <FormInput
              label={t("Product Name")}
              type="text"
              errors={errorsProduct?.data}
              value={formData.product_name}
              name="product_name"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Video URL")}
              type="text"
              errors={errorsProduct?.data}
              value={formData.video_url}
              name="video_url"
              onChange={inputHandler}
              containerClass="mb-3"
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Manufactured By")}
              type="text"
              errors={errorsProduct?.data}
              value={formData.manufactured_by}
              name="manufactured_by"
              onChange={inputHandler}
              containerClass="mb-3"
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Price")}
              type="number"
              errors={errorsProduct?.data}
              value={formData.price}
              name="price"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Location")}
              type="text"
              errors={errorsProduct?.data}
              value={formData.location}
              name="location"
              onChange={inputHandler}
              containerClass="mb-3"
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Description")}
              type="textarea"
              errors={errorsProduct?.data}
              value={formData.description}
              name="description"
              onChange={inputHandler}
              containerClass="mb-3"
            />
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col lg={4}>

            <FormInput
              label={t("Image URL")}
              type="file"
              errors={errorsProduct?.data}
              name="product_image"
              onChange={inputHandler}
              containerClass="mb-3"
            />
          </Col>
          <Col lg={2}>
            <div className="image-preview">
              {formData.imagePreview && (
                <Button >View</Button>
                // <img src={formData.imagePreview} alt="preview" />
              )}
            </div>
          </Col>
        </Row>
        <div className="d-flex justify-content-center">
          {loadingProduct ? (
            <Button color="primary" disabled>
              <Spinner animation="border" size="sm" />
              {t("Please wait ...")}
            </Button>
          ) : (
            <Button type="button" onClick={handleSubmit} disabled={loadingProduct}>
              {editId && productDetails ? t("Update") : t("Add")}
            </Button>
          )}
        </div>
      </Modal.Body>
      {loadingProduct && <Preloader />}
    </Modal>
  );
};

export default AddProduct;
